export const getFormattedProgressAndRemainingTime = (position, duration) => {
    const hours = Math.floor(position / 60 / 60);
    const minutes = Math.floor((position / 60) - (hours * 60));
    const seconds = Math.floor(position - (minutes * 60) - (hours * 60 * 60));
    const remaining = (duration - position);
    const hoursRemaining = Math.floor(remaining / 60 / 60);
    const minutesRemaining = Math.floor((remaining / 60) - (hoursRemaining * 60));
    const secondsRemaining = Math.floor(remaining - (minutesRemaining * 60) - (hoursRemaining * 60 * 60));
    let timeProgressed = `${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
    let timeRemaining = `${minutesRemaining.toString().padStart(2, '0')}:${secondsRemaining.toString().padStart(2, '0')}`;
    if (hours) {
        timeProgressed = `${hours}:${timeProgressed}`;
    }
    if (hoursRemaining) {
        timeRemaining = `${hoursRemaining}:${timeRemaining}`;
    }
    let timeRemainingShort = `${hoursRemaining ? `${hoursRemaining}h` : ''} ${minutesRemaining}m left`;
    if (timeRemainingShort.endsWith(' 0min left')) {
        timeRemainingShort = 'less than 1m left';
    }
    return {
        position,
        duration,
        hours,
        minutes,
        seconds,
        remaining,
        hoursRemaining,
        minutesRemaining,
        secondsRemaining,
        timeProgressed,
        timeRemaining: `- ${timeRemaining}`,
        timeRemainingShort: timeRemainingShort.trim(),
    };
};
//# sourceMappingURL=getFormattedProgressAndRemainingTime.js.map